// @todo this is used only in the header only mode, can we not use the hook instead?
import { createBrowserHistory } from 'history'

export default createBrowserHistory()
